// extracted by mini-css-extract-plugin
module.exports = {"section":"_2kp-U1vYvL_G81Qw2evpJY","block":"_1wCMH4U66DMVSKbmXQ4-8p"};